import script from "./notice.vue?vue&type=script&setup=true&lang=js"
export * from "./notice.vue?vue&type=script&setup=true&lang=js"

import "./notice.vue?vue&type=style&index=0&id=b16368c2&lang=scss"

const __exports__ = script;

export default __exports__